
// version.ts
export const VERSION = '0.1.1'; // Update this manually on each release

